import React from 'react';
import { ShieldCheck } from 'lucide-react';
import { CTAButton } from './CTAButton';
export function PricingSection() {
  const valueItems = [{
    name: 'The Snap-Back Blueprint (60-Page Main Guide)',
    price: '$27.00'
  }, {
    name: 'Bonus #1: The "Quiet-House" Protocol (Video-Integrated)',
    price: '$12.00'
  }, {
    name: 'Bonus #2: The 10-Min "Mom-Fuel" Kitchen (Recipes)',
    price: '$12.00'
  }, {
    name: 'Bonus #3: The Brain-Fog Eraser (Cognitive Guide)',
    price: '$9.00'
  }, {
    name: 'Bonus #4: The "Back to Sexy" Identity Journal',
    price: '$15.00'
  }, {
    name: 'Bonus #5: C-Section Recovery Secrets (Healing Plan)',
    price: '$12.00'
  }];
  return <section id="pricing-section" className="py-12 md:py-24 px-4 bg-brand-cream" data-id="element-123">
      <div className="max-w-4xl mx-auto" data-id="element-124">
        <div className="bg-white rounded-3xl shadow-xl overflow-hidden border border-brand-gold/20" data-id="element-125">
          <div className="p-8 md:p-12 text-center border-b border-brand-cream" data-id="element-126">
            <div className="inline-block bg-red-100 text-red-700 font-bold px-4 py-1 rounded-full text-sm mb-6 animate-pulse" data-id="element-127">
              85% OFF SPECIAL OFFER
            </div>

            {/* Value Stack Table */}
            <div className="max-w-2xl mx-auto mb-10" data-id="element-128">
              <h3 className="text-xl font-bold font-heading mb-4 text-brand-charcoal" data-id="element-129">
                Your Postpartum Transformation System
              </h3>
              <p className="text-xs text-brand-charcoal/50 mb-3 md:hidden" data-id="element-130">
                ← Scroll to see full table →
              </p>
              <div className="overflow-x-auto" data-id="element-131">
                <table className="w-full text-left" data-id="element-132">
                  <tbody data-id="element-133">
                    {valueItems.map((item, idx) => <tr key={idx} className={idx % 2 === 0 ? 'bg-brand-cream/30' : 'bg-white'} data-id="element-134">
                        <td className="py-3 px-4 text-brand-charcoal/80 text-sm md:text-base" data-id="element-135">
                          {item.name}
                        </td>
                        <td className="py-3 px-4 text-right font-medium text-brand-charcoal whitespace-nowrap" data-id="element-136">
                          {item.price}
                        </td>
                      </tr>)}
                    <tr className="border-t-2 border-brand-gold/30" data-id="element-137">
                      <td className="py-3 px-4 font-bold text-brand-charcoal" data-id="element-138">
                        TOTAL VALUE PRICE:
                      </td>
                      <td className="py-3 px-4 text-right font-bold text-brand-charcoal line-through decoration-red-500 decoration-2" data-id="element-139">
                        $87.00
                      </td>
                    </tr>
                    <tr data-id="element-140">
                      <td className="py-3 px-4 font-bold text-brand-charcoal/70" data-id="element-141">
                        REGULAR PRICE:
                      </td>
                      <td className="py-3 px-4 text-right font-bold text-brand-charcoal/70 line-through" data-id="element-142">
                        $47.00
                      </td>
                    </tr>
                    <tr className="bg-brand-coral/10" data-id="element-143">
                      <td className="py-4 px-4 font-bold text-brand-coral text-lg" data-id="element-144">
                        SPECIAL OFFER:
                      </td>
                      <td className="py-4 px-4 text-right font-bold text-brand-coral text-2xl" data-id="element-145">
                        $6.39
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>

            <h2 className="text-4xl md:text-5xl font-bold text-brand-charcoal mb-4" data-id="element-146">
              GET THE ENTIRE BUNDLE TODAY FOR ONLY{' '}
              <span className="text-brand-coral" data-id="element-147">$6.39</span>
            </h2>

            <p className="max-w-2xl mx-auto text-lg text-brand-charcoal/80 italic leading-relaxed mt-6 mb-2" data-id="element-148">
              "Why only $6.39? Because I know what it's like to feel lost in
              your own body, and I refuse to let a 'premium price tag' be the
              reason you don't find yourself again. This is for every mom who is
              tired of the 'Snap-Back' lies and just wants real, honest
              recovery. Click below, skip one coffee, and reclaim your body
              today."
            </p>

            <div className="mt-10" data-id="element-149">
              <CTAButton text="YES! I WANT MY IDENTITY BACK – ACCESS NOW FOR $6.39" subtext="Instant Digital Access | Secure Checkout" data-id="element-150" />
            </div>
          </div>

          <div className="bg-brand-sage/5 p-8 md:p-12" data-id="element-151">
            <div className="flex flex-col md:flex-row items-center gap-8" data-id="element-152">
              <div className="shrink-0" data-id="element-153">
                <ShieldCheck className="w-24 h-24 text-brand-sage" data-id="element-154" />
              </div>
              <div data-id="element-155">
                <h3 className="text-2xl font-bold mb-3 font-heading" data-id="element-156">
                  100% "Mom-Joy" Guarantee
                </h3>
                <p className="text-brand-charcoal/80 leading-relaxed mb-4" data-id="element-157">
                  If you don't feel more energized, stronger, and more confident
                  in the next 7 days, I'll give you every penny back. Keep the
                  bonuses as my gift to you for trying.
                </p>
                <p className="font-bold text-brand-sage" data-id="element-158">
                  Zero Risk. All Reward.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}